export const CONTEXT_RETURN_URL_QUERY_PARAM = 'returnUrl';
export const LOGIN_REASON_QUERY_PARAM = 'reason';
export const SESSION_EXPIRED_LOGIN_REASON = 'session-expired';

export type LoginReason = typeof SESSION_EXPIRED_LOGIN_REASON;

export function normalizeContextReturnUrl(value: string | null | undefined): string {
  if (value === null || value === undefined) {
    return '/';
  }

  const candidate = value.trim();
  if (!candidate.startsWith('/') || candidate.startsWith('//')) {
    return '/';
  }

  const path = candidate.split(/[?#]/, 1)[0];
  if (path === '/login' || path === '/select-tenant' || path === '/select-context') {
    return '/';
  }

  return candidate;
}

export function parseLoginReason(value: string | null | undefined): LoginReason | null {
  return value === SESSION_EXPIRED_LOGIN_REASON ? SESSION_EXPIRED_LOGIN_REASON : null;
}
